import React, { useState } from "react";
import { Button, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import CierreDeCajaForm from "./CierreDeCajaForm";
import CierreDeCajaList from "./CierreDeCajaList";
import "./CierreDeCajaStyles.css";

const CierreDeCajaManagement = () => {
	const [showForm, setShowForm] = useState(false);
	const [selectedCierre, setSelectedCierre] = useState(null);
	const [refreshTrigger, setRefreshTrigger] = useState(0);

	const handleAddCierreDeCaja = () => {
		setSelectedCierre(null);
		setShowForm(true);
	};

	const handleEditCierreDeCaja = (cierre) => {
		setSelectedCierre(cierre);
		setShowForm(true);
	};

	const handleCierreDeCajaSaved = () => {
		setShowForm(false);
		setRefreshTrigger((prev) => prev + 1);
	};

	const handleCancel = () => {
		setShowForm(false);
	};

	return (
		<div className="cierreDeCaja-management-container">
			{showForm ? (
				<CierreDeCajaForm
					cierre={selectedCierre}
					onSave={handleCierreDeCajaSaved}
					onCancel={handleCancel}
				/>
			) : (
				<React.Fragment>
					<Row
						justify="space-between"
						align="middle"
						style={{ marginBottom: 16 }}
					>
						<Col>
							<h1>Gestión de Cierres de Caja</h1>
						</Col>
						<Col>
							<Button
								type="primary"
								icon={<PlusOutlined />}
								onClick={handleAddCierreDeCaja}
							>
								Nuevo Cierre de Caja
							</Button>
						</Col>
					</Row>

					<CierreDeCajaList
						refreshTrigger={refreshTrigger}
						onEdit={handleEditCierreDeCaja}
					/>
				</React.Fragment>
			)}
		</div>
	);
};

export default CierreDeCajaManagement;
